import styled from "styled-components";

import { Text } from "/component/base";
import { layout } from "/styles";

export const ProvidersTitle = styled(Text)(layout.padding("skip", "skip", "standard"), {
  display: "block",
});
